import React, { useEffect } from "react";




const Temp = () => {

    console.log("Temp.jsx");
    return (
        <div>
            <h1>Temp!!!</h1>
        </div>
    );
}
export default Temp;

